import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import * as React from "react";
import { cn } from "../utils";

export const Accordion = AccordionPrimitive.Root;

export interface AccordionItemProps extends AccordionPrimitive.AccordionItemProps {}
export const AccordionItem = React.forwardRef<HTMLDivElement, AccordionItemProps>(
  ({ className, ...props }, ref) => (
    <AccordionPrimitive.Item
      ref={ref}
      className={cn(
        "border border-[color:var(--color-text,#0f172a)]/12 rounded-xl bg-[var(--color-surface,#fff)] text-[var(--color-text,#0f172a)] shadow-sm",
        className
      )}
      {...props}
    />
  )
);
AccordionItem.displayName = "AccordionItem";

export interface AccordionTriggerProps extends AccordionPrimitive.AccordionTriggerProps {}
export const AccordionTrigger = React.forwardRef<HTMLButtonElement, AccordionTriggerProps>(
  ({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        ref={ref}
        className={cn(
          "group flex flex-1 items-center justify-between gap-3 px-4 py-3 text-left text-base font-semibold",
          "text-[var(--color-text,#0f172a)]",
          "transition-all hover:bg-primary/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-2 rounded-lg",
          className
        )}
        {...props}
      >
        <span className="flex-1">{children}</span>
        <ChevronDown className="h-4 w-4 text-[var(--color-text,#0f172a)]/70 transition-transform group-data-[state=open]:rotate-180" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
);
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

export interface AccordionContentProps extends AccordionPrimitive.AccordionContentProps {}
export const AccordionContent = React.forwardRef<HTMLDivElement, AccordionContentProps>(
  ({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Content
      ref={ref}
      className={cn(
        "px-4 pb-4 pt-0",
        className
      )}
      {...props}
    >
      <div className="pt-1" style={{ color: "var(--color-text,#0f172a)", opacity: 0.82 }}>
        {children}
      </div>
    </AccordionPrimitive.Content>
  )
);
AccordionContent.displayName = AccordionPrimitive.Content.displayName;
